import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioInicialConsultaConvenioRecebido: ['exercicioInicial'],
    removeExercicioFinalConsultaConvenioRecebido: ['exercicioFinal'],
    removeCodigoInicialConsultaConvenioRecebido: ['codigoInicial'],
    removeCodigoFinalConsultaConvenioRecebido: ['codigoFinal'],
    removeAssinaturaInicialConsultaConvenioRecebido: ['assinaturaInicial'],
    removeAssinaturaFinalConsultaConvenioRecebido: ['assinaturaFinal'],
    removeTipoConsultaConvenioRecebido: ['tipo'],
    removeAdministracaoConsultaConvenioRecebido: ['administracao'],
    removeDescricaoLocalFisicoConsultaConvenioRecebido: ['descricaoLocalFisico'],
    removeConvenenteConsultaConvenioRecebido: ['convenente'],
    removeConcedenteConsultaConvenioRecebido: ['concedente'],
    removeIntervenienteConsultaConvenioRecebido: ['interveniente'],
    removeObjetoConsultaConvenioRecebido: ['objeto'],
    removeSituacaoConsultaConvenioRecebido: ['situacao'],
    removeExercicioLicitacaoInicialConsultaConvenioRecebido: ['exercicioLicitacaoInicial'],
    removeExercicioLicitacaoFinalConsultaConvenioRecebido: ['exercicioLicitacaoFinal'],
    removeNumeroLicitacaoInicialConsultaConvenioRecebido: ['numeroLicitacaoInicial'],
    removeNumeroLicitacaoFinalConsultaConvenioRecebido: ['numeroLicitacaoFinal'],
    removeModalidadeLicitacaoConsultaConvenioRecebido: ['modalidadeLicitacao'],
    setMostraAplicarFiltroConsultaConvenioRecebido: [],
    limpaFiltroConsultaConvenioRecebido: [],
    aplicarFiltroConsultaConvenioRecebido: ['filtro'],
})

const INITIAL_STATE = {
    exercicioInicial: '',
    exercicioFinal: '',
    codigoInicial: '',
    codigoFinal: '',
    assinaturaInicial: '',
    assinaturaFinal: '',
    tipo: [],
    administracao: [],
    descricaoLocalFisico: '',
    convenente: '',
    concedente: '',
    interveniente: '',
    objeto: '',
    situacao: [],
    exercicioLicitacaoInicial: '',
    exercicioLicitacaoFinal: '',
    numeroLicitacaoInicial: '',
    numeroLicitacaoFinal: '',
    modalidadeLicitacao: [],
    mostraAplicarFiltro: false,
}

const removeTipo = (state = INITIAL_STATE, action) => {
    state.tipo.splice(state.tipo.indexOf(action.tipo), 1)
    state.tipo = Array.from(state.tipo)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeModalidadeLicitacao = (state = INITIAL_STATE, action) => {
    state.modalidadeLicitacao.splice(state.modalidadeLicitacao.indexOf(action.modalidadeLicitacao), 1)
    state.modalidadeLicitacao = Array.from(state.modalidadeLicitacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: '', mostraAplicarFiltro: true }
}
const removeCodigoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, codigoInicial: '', mostraAplicarFiltro: true }
}
const removeCodigoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoFinal: '', mostraAplicarFiltro: true }
}
const removeAssinaturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaInicial: '', mostraAplicarFiltro: true }
}
const removeAssinaturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaFinal: '', mostraAplicarFiltro: true }
}
const removeDescricaoLocalFisico = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoLocalFisico: '', mostraAplicarFiltro: true }
}
const removeConvenente = (state = INITIAL_STATE, action) => {
    return { ...state, convenente: '', mostraAplicarFiltro: true }
}
const removeConcedente = (state = INITIAL_STATE, action) => {
    return { ...state, concedente: '', mostraAplicarFiltro: true }
}
const removeInterveniente = (state = INITIAL_STATE, action) => {
    return { ...state, interveniente: '', mostraAplicarFiltro: true }
}
const removeObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: '', mostraAplicarFiltro: true }
}
const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}
const removeExercicioLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoFinal: '', mostraAplicarFiltro: true }
}
const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}
const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_INICIAL_CONSULTA_CONVENIO_RECEBIDO]: removeExercicioInicial,
    [Types.REMOVE_EXERCICIO_FINAL_CONSULTA_CONVENIO_RECEBIDO]: removeExercicioFinal,
    [Types.REMOVE_CODIGO_INICIAL_CONSULTA_CONVENIO_RECEBIDO]: removeCodigoInicial,
    [Types.REMOVE_CODIGO_FINAL_CONSULTA_CONVENIO_RECEBIDO]: removeCodigoFinal,
    [Types.REMOVE_ASSINATURA_INICIAL_CONSULTA_CONVENIO_RECEBIDO]: removeAssinaturaInicial,
    [Types.REMOVE_ASSINATURA_FINAL_CONSULTA_CONVENIO_RECEBIDO]: removeAssinaturaFinal,
    [Types.REMOVE_TIPO_CONSULTA_CONVENIO_RECEBIDO]: removeTipo,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_CONVENIO_RECEBIDO]: removeAdministracao,
    [Types.REMOVE_DESCRICAO_LOCAL_FISICO_CONSULTA_CONVENIO_RECEBIDO]: removeDescricaoLocalFisico,
    [Types.REMOVE_CONVENENTE_CONSULTA_CONVENIO_RECEBIDO]: removeConvenente,
    [Types.REMOVE_CONCEDENTE_CONSULTA_CONVENIO_RECEBIDO]: removeConcedente,
    [Types.REMOVE_INTERVENIENTE_CONSULTA_CONVENIO_RECEBIDO]: removeInterveniente,
    [Types.REMOVE_OBJETO_CONSULTA_CONVENIO_RECEBIDO]: removeObjeto,
    [Types.REMOVE_SITUACAO_CONSULTA_CONVENIO_RECEBIDO]: removeSituacao,
    [Types.REMOVE_EXERCICIO_LICITACAO_INICIAL_CONSULTA_CONVENIO_RECEBIDO]: removeExercicioLicitacaoInicial,
    [Types.REMOVE_EXERCICIO_LICITACAO_FINAL_CONSULTA_CONVENIO_RECEBIDO]: removeExercicioLicitacaoFinal,
    [Types.REMOVE_NUMERO_LICITACAO_INICIAL_CONSULTA_CONVENIO_RECEBIDO]: removeNumeroLicitacaoInicial,
    [Types.REMOVE_NUMERO_LICITACAO_FINAL_CONSULTA_CONVENIO_RECEBIDO]: removeNumeroLicitacaoFinal,
    [Types.REMOVE_MODALIDADE_LICITACAO_CONSULTA_CONVENIO_RECEBIDO]: removeModalidadeLicitacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_CONVENIO_RECEBIDO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_CONVENIO_RECEBIDO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_CONVENIO_RECEBIDO]: aplicarFiltro,
})
